// src/utils/utm.js
const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

// --- cookies (fallback) ---
function setCookie(name, value, days = 7) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}
function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

// --- session helpers ---
function saveToSession(obj) {
  try {
    sessionStorage.setItem("utm_payload", JSON.stringify(obj));
  } catch (_) {}
}
function readFromSession() {
  try {
    const raw = sessionStorage.getItem("utm_payload");
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

// --- main APIs you’ll use ---
export function captureUTMFromURL(locationSearch = window.location.search) {
  const params = new URLSearchParams(locationSearch);
  const utm = {};
  let found = false;

  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v && String(v).trim() !== "") {
      utm[k] = v.trim();
      found = true;
    }
  });

  // Add a couple of useful attribution extras (optional)
  const gclid = params.get("gclid");
  const fbclid = params.get("fbclid");
  if (gclid) utm.gclid = gclid;
  if (fbclid) utm.fbclid = fbclid;

  if (!found && !gclid && !fbclid) {
    // If URL has no UTM, don't overwrite existing captured values
    return getUTM(); // no-op, but returns existing if present
  }

  // stamp landing info
  utm.landing_url = window.location.href;
  utm.landing_at = new Date().toISOString();
  utm.referrer = document.referrer || "";

  // persist
  saveToSession(utm);
  setCookie("utm_payload", JSON.stringify(utm), 7);
  return utm;
}

export function getUTM() {
  // 1) sessionStorage
  const s = readFromSession();
  if (s) return s;

  // 2) cookie
  const c = getCookie("utm_payload");
  if (c) {
    try {
      const parsed = JSON.parse(c);
      // refresh session for faster access
      saveToSession(parsed);
      return parsed;
    } catch (_) {
      return null;
    }
  }
  return null;
}

// Use this just before sending to backend, to avoid sending empty keys
export function getUTMForSubmit() {
  const data = getUTM() || {};
  const cleaned = {};
  Object.keys(data || {}).forEach((k) => {
    const v = data[k];
    if (v !== undefined && v !== null && String(v).trim() !== "") {
      cleaned[k] = String(v).trim();
    }
  });
  return cleaned;
}

// If you ever need to clear after purchase:
export function clearUTM() {
  try { sessionStorage.removeItem("utm_payload"); } catch (_) {}
  setCookie("utm_payload", "", -1);
}
